import type { RouteLocationMatched } from 'vue-router'
import {
  AdminRole,
  SIDEBAR_NAV,
  type SidebarNavItem,
} from '@/modules/Core/constants/adminAccess'

export function canAccess(
  role: AdminRole | string | null | undefined,
  allowedRoles: AdminRole[]
): boolean {
  if (!role) {
    return false
  }

  if (role === AdminRole.Admin) {
    return true
  }

  return allowedRoles.includes(role as AdminRole)
}

export function getRouteAllowedRoles(
  matched: RouteLocationMatched[]
): AdminRole[] | undefined {
  for (let index = matched.length - 1; index >= 0; index -= 1) {
    const allowedRoles = matched[index].meta.allowedRoles

    if (allowedRoles) {
      return allowedRoles
    }
  }

  return undefined
}

export function getAccessibleSidebarItems(
  role: AdminRole | string | null | undefined
): SidebarNavItem[] {
  return SIDEBAR_NAV.filter((item) => canAccess(role, item.allowedRoles))
}

export function getFirstAccessiblePath(
  role: AdminRole | string | null | undefined
): string | null {
  const firstItem = getAccessibleSidebarItems(role)[0]
  return firstItem?.link ?? null
}
